import { Component, Prop, Mixins, Watch } from 'vue-property-decorator'
import { Line, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

@Component({
	mixins: [reactiveProp]
})

export default class LineChart extends Mixins(Line) {

  @Prop()
  private chartData!: any;

  @Prop()
  private chartOptions!: any;

  @Watch('chartData', { immediate: false, deep: true })
  updateChart (next: any, prev: any) {

    if (next.labels != null && next.labels != prev.labels) {

      this.renderChart(this.chartData, this.chartOptions)
    }
  }

  mounted() {

    this.renderChart(this.chartData, this.chartOptions)
  }
}